import { useTranslation } from 'react-i18next';
import type { BankReconciliationRunSummary } from '../../api/client';

export default function RunSummary({ summary }: { summary: BankReconciliationRunSummary }) {
  const { t, i18n } = useTranslation();
  const money = (value: number) => new Intl.NumberFormat(i18n.language, {
    style: 'currency', currency: summary.currency || 'ILS',
  }).format(value);
  const stats = [
    ['incoming', summary.incoming_payment_rows],
    ['suggestions', summary.suggestion_count],
    ['matched', money(summary.matched_total)],
    ['unallocated', money(summary.unmatched_total)],
    ['executed', summary.executed_count],
    ['resolved', summary.resolved_count ?? 0],
  ];
  return (
    <section aria-label={t('reconciliation.summary.title')} className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-6">
      {stats.map(([key, value]) => (
        <div key={key} className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <p className="text-xs font-medium uppercase tracking-wide text-gray-500">{t(`reconciliation.summary.${key}`)}</p>
          <p className="mt-1 text-xl font-bold text-gray-900">{value}</p>
        </div>
      ))}
    </section>
  );
}
